<template>
  <div :class="[compact ? 'compact' : '', 'header']">
    <div class="container-fluid">
      <!-- Body -->
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <!-- Pretitle -->
            <h6 class="header-pretitle">{{pretitle}}</h6>
            <div v-if="title" class="position-relative d-inline-block">
              <h1 class="header-title" v-html="title"></h1>
              <HelpIcon />
            </div>
            <!-- Secondary Title -->
            <h4 class="header-title">{{secondaryTitle}}</h4>
          </div>
          <!-- Button -->
          <div v-if="buttonText" class="col-auto ps-1">
            <button @click="btnClick" class="btn" :class="[buttonClass, !ignoreButtonLift ? 'lift' : '']" :disabled="buttonDisabled || (!buttonRoles.length || isAccessByUserRole(buttonRoles) ? false:true)"><slot></slot>
              <span v-if="buttonLoading" class="spinner-border spinner-border-sm me-1" style="width: 1em; height: 1em;"></span>
              <i v-else-if="buttonIconClass" :class="buttonIconClass"></i>
              {{buttonText}} 
              <i v-if="buttonRoles.length && !isAccessByUserRole(buttonRoles)" class="fa fa-circle-exclamation" title="Your user do not have permission .Please contact support" data-bs-toggle="tooltip" data-bs-placement="right"></i>                                    
            </button>
          </div>
          <div v-if="buttonText2" class="col-auto ps-1">
            <button @click="btnClick2" class="btn" :class="[buttonClass2, !ignoreButtonLift2 ? 'lift' : '']" :disabled="buttonDisabled2 || (!button2Roles.length || isAccessByUserRole(button2Roles) ? false:true)"><slot></slot>
              <span v-if="buttonLoading2" class="spinner-border spinner-border-sm me-1" style="width: 1em; height: 1em;"></span>
              <i v-else-if="buttonIconClass2" :class="buttonIconClass2"></i>
              {{buttonText2}} 
              <i v-if="button2Roles.length && !isAccessByUserRole(button2Roles)" class="fa fa-circle-exclamation" title="Your user do not have permission .Please contact support" data-bs-toggle="tooltip" data-bs-placement="right"></i>                                   
            </button>
          </div>
          <div v-if="buttonText3" class="col-auto ps-1">
            <button @click="btnClick3" class="btn" :class="[buttonClass3, !ignoreButtonLift3 ? 'lift' : '']" :disabled="buttonDisabled3 || (!button3Roles.length || isAccessByUserRole(button3Roles) ? false:true)"><slot></slot>
              <span v-if="buttonLoading3" class="spinner-border spinner-border-sm me-1" style="width: 1em; height: 1em;"></span>
              <i v-else-if="buttonIconClass3" :class="buttonIconClass3"></i>
              {{buttonText3}} 
              <i v-if="button3Roles.length && !isAccessByUserRole(button3Roles)" class="fa fa-circle-exclamation" title="Your user do not have permission .Please contact support" data-bs-toggle="tooltip" data-bs-placement="right"></i>                                   
            </button>
          </div>
          <div v-if="sideTitle" class="col-auto">
            <h3>{{sideTitle}}</h3>
          </div>
        </div>
        <!-- / .row -->
      </div>
      <!-- / .header-body -->
    </div>
  </div>
</template>

<script>
import HelpIcon from './HelpIcon.vue';

export default {
    name: 'BasicHeader',
    components: { HelpIcon },
    props: {
        'pretitle': String,
        'title': String,
        'secondaryTitle': String,
        'sideTitle': String,
        'buttonText': String,
        'buttonIconClass': String,
        'buttonLoading': {
          type: Boolean,
          default: false
        },
        'ignoreButtonLift': {
          type: Boolean,
          default: false
        },
        'compact': Boolean,
        'buttonClass': {
          type: String,
          default: "btn-primary"
        },
        'buttonDisabled': {
          type: Boolean,
          default: false
        },
        'buttonText2': String,
        'buttonIconClass2': String,
        'buttonLoading2': {
          type: Boolean,
          default: false
        },
        'ignoreButtonLift2': {
          type: Boolean,
          default: false
        },
        'buttonClass2': {
          type: String,
          default: "btn-secondary"
        },
        'buttonDisabled2': {
          type: Boolean,
          default: false
        },
        'buttonRoles':{
          type: Array,
          default: function () {
              return []
          }
        },
        'button2Roles': {
          type: Array,
          default: function () {
              return []
          }
        },
        'buttonText3': String,
        'buttonIconClass3': String,
        'buttonLoading3': {
          type: Boolean,
          default: false
        },
        'ignoreButtonLift3': {
          type: Boolean,
          default: false
        },
        'buttonClass3': {
          type: String,
          default: "btn-secondary"
        },
        'buttonDisabled3': {
          type: Boolean,
          default: false
        },
        'button3Roles': {
          type: Array,
          default: function () {
              return []
          }
        }
    },
    methods:{
      btnClick() {
        this.$emit('btnClick')
      },
      btnClick2() {
        this.$emit('btnClick2')
      },
      btnClick3() {
        this.$emit('btnClick3')
      },
      isAccessByUserRole(roles) {
        return this.$store.getters.userRoles.isAccessByRole(roles);
      } 
    },   
    emits: [
      'btnClick',
      'btnClick2',
      'btnClick3'
    ]
};
</script>

<style>
</style>